import React from "react";
import "./Separation.css"

function Separation() {
    return (
        <div className="separation">

        </div>
    )
}

export default Separation